export const generateProjectName = () => {
  let projectName = ''
  switch (process.env.VUE_APP_ENV || process.env.VUE_APP_FORMATS) {
    case 'gznt': //广州南投
      projectName = '广州南投标准管理平台'
      break;
    case 'wm': //望美
      projectName = '望美标准管理平台'
      break;
    case 'xyh': //溪悦荟
      projectName = '溪悦荟标准管理平台'
      break;
    case 'atls': //奥特莱斯
      projectName = '百联物业管理平台'
      break;
    case 'hwkz': //华为框招
      projectName = '华为框招标准管理平台'
      break;
    case 'business': //商写
      projectName = '星启中台-商写'
      break;
    case 'campus': //校园
      projectName = '星启中台-校园标准'
      break;
    case 'house': //住宅
      projectName = '星启中台-住宅'
      break;
    case 'guard': //智能制造园区
      projectName = '制造业园区标准管理平台'
      break;
    case 'kangYang': //康养
      projectName = '星启中台-康养'
      break;
    case 'zbds': //总部大厦
      projectName = '星启中台-总部大厦'
      break;
    case 'fullIndustry': //智慧园区综合管理平台
      projectName = '智慧园区综合管理平台'
      break;
    case 'zh': //纵横管理平台
      projectName = '纵横管理平台'
      break;
    case 'xmtyg': //厦门奥林匹克体育中心
      projectName = '厦门奥林匹克体育中心'
      break;
    case 'kl': // 新发展楷林智慧广场
      projectName = '新发展楷林智慧广场'
      break;
    case 'clhk': // 长龙航空维修工程项目
    projectName = '长龙航空维修工程项目'
    break;
    default:
      projectName = '星启中台-商写'
  }
  return projectName
}